var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
var Root = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  animation: ", ";\n"], ["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  animation: ", ";\n"])), function (_a) {
    var $show = _a.$show;
    return "".concat($show ? 'fadeIn' : 'fadeOut', " 300ms forwards, ").concat($show ? 'zoomIn' : 'zoomOut', " 300ms forwards");
});
var FadeTransition = function (_a) {
    var children = _a.children, show = _a.show;
    var _b = __read(useState(show), 2), render = _b[0], setRender = _b[1];
    useEffect(function () {
        if (show) {
            setRender(true);
        }
    }, [show]);
    var onAnimationEnd = function () {
        if (!show) {
            setRender(false);
        }
    };
    return render ? (React.createElement(Root, { "$show": show, onAnimationEnd: onAnimationEnd }, children)) : null;
};
export default FadeTransition;
var templateObject_1;
//# sourceMappingURL=FadeTransition.js.map